module.exports = __webpack_public_path__ + "static/media/world2.6a94fc23.svg";